"use strict";

console.log("custom collection");
var filterBar = document.querySelector(".custom-collection-filter-bar");
var observer = new IntersectionObserver(function (entries) {
  entries.forEach(function (entry) {
    if (entry.isIntersecting) {
      entry.target.classList.add("visible");
      filterBar.style.position = "absolute";
    } else {
      filterBar.style.position = "fixed";
    }
  });
});
var targetElement = document.querySelector(".inselberg-footer");
observer.observe(targetElement);
function initialColorSwatch() {
  var colorSwatches = document.querySelector(".custom-collection-wrapper").querySelectorAll(".color-item");
  colorSwatches.forEach(function (swatch) {
    swatch.addEventListener("click", function (e) {
      e.preventDefault();
      var parent = swatch.closest(".custom-card-product");
      var mainCover = swatch.getAttribute("data-main-cover");
      var secondaryCover = swatch.getAttribute("data-secondary-cover");
      var url = swatch.getAttribute("data-url");
      parent.querySelector(".product-cover").setAttribute("data-href", url);
      parent.querySelector(".main-cover").src = mainCover;
      parent.querySelector(".secondary-cover").src = secondaryCover;
      parent.querySelectorAll(".color-item").forEach(function (item) {
        item.classList.remove("active");
      });
      swatch.classList.add("active");
    });
  });
}
initialColorSwatch();
function navigateToProductPage() {
  var productCovers = document.querySelectorAll(".product-cover");
  productCovers.forEach(function (cover) {
    cover.addEventListener("click", function () {
      var url = cover.getAttribute("data-href");
      if (url) {
        window.location.href = url;
      }
    });
  });
}
navigateToProductPage();